module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "fl p-r-10 m-r-10 bor-r-ccc",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "页面名称（标题）",
      "prop": "name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称（标题）"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        _vm.form.name = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "页面描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "w-200",
    attrs: {
      "type": "textarea",
      "placeholder": "请输入描述"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        _vm.form.description = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "页面类型",
      "prop": "type"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type),
      expression: "form.type"
    }],
    domProps: {
      "value": (_vm.form.type)
    },
    on: {
      "input": function($event) {
        _vm.form.type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": _vm.LAYOUT_FLOW
    }
  }, [_vm._v("顺序布局")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": _vm.LAYOUT_FLOW_TAB
    }
  }, [_vm._v("顺序-TAB布局")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主题样式",
      "prop": "theme"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.theme),
      expression: "form.theme"
    }],
    domProps: {
      "value": (_vm.form.theme)
    },
    on: {
      "input": function($event) {
        _vm.form.theme = $event
      }
    }
  }, _vm._l((_vm.themeList), function(theme) {
    return _c('el-option', {
      attrs: {
        "label": theme.title,
        "value": theme.theme
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "功能组件配置",
      "prop": "parts"
    }
  }, [_c('parts-table', {
    attrs: {
      "parts-data": _vm.form.partsConfig,
      "models-by-id": _vm.modelsById
    },
    on: {
      "setCurPart": _vm.setCurPart,
      "deletePart": _vm.deletePart
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 tx-c"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addPart
    }
  }, [_vm._v("添加")])])]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])]), _vm._v(" "), (_vm.showConfig) ? _c('right-config', {
    staticClass: "fl",
    attrs: {
      "models": _vm.models,
      "form": _vm.curConfig
    },
    on: {
      "openRule": _vm.openRule
    }
  }) : _vm._e(), _vm._v(" "), _c('rule-list', {
    ref: "ruleList",
    attrs: {
      "title": "权限规则绑定"
    },
    on: {
      "selectRule": _vm.selectRule
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-741b141a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/page/form.vue
// module id = 1923
// module chunks = 2